//Built-in libraries
import { useState } from 'react';

//Third party libraries
import { XIcon } from '@heroicons/react/solid';
import { LocationMarkerIcon } from '@heroicons/react/solid';
import { Link, useLocation } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';

//custom components
import GoogleMap from 'components/UI/GoogleMap';
import Card from '../../UI/Card';
import LoadingMapCard from '../../UI/loading/Dashboard/LoadingMapCard';
import LocationMarker from 'components/UI/GoogleMap/LocationMarker';
import { PhoneNumberFormatDisplay } from 'components/UI/NumberFormatDisplay/PhoneNumberFormatDisplay';

//services
import { getAddressDecode, IGetAddressDecodeResData } from 'api/misc';

//Assets and miscellaneous

// const dummyData = [
//   {
//     id: '1',
//     name: 'Test 1',
//     address: '123 main street',
//     city: 'New York',
//     state: 'NY',
//     zipCode: '11101',
//     clergyLeader: 'Test Red',
//     email: 'test1@mail.com',
//     phone: 2344343423,
//     website: 'test1.com',
//     coordinates: { lat: 40.7127281, lng: -74.0060152 },
//   },
//   {
//     id: '2',
//     name: 'Test 2',
//     address: '45 groove street',
//     city: 'Baltimore',
//     state: 'MD',
//     zipCode: '22123',
//     clergyLeader: 'Test Red2',
//     email: 'test2@mail.com',
//     phone: 3454323234,
//     website: 'test2.com',
//     coordinates: { lat: 39.2908816, lng: -76.610759 },
//   },
//   {
//     id: '3',
//     name: 'Test3',
//     address: '122 fortworth street',
//     city: 'Houston',
//     state: 'TX',
//     zipCode: '77623',
//     clergyLeader: 'Test Red3',
//     email: 'test3@mail.com',
//     phone: 3453233444,
//     website: 'test3.com',
//     coordinates: { lat: 29.7589382, lng: -95.3676974 },
//   },
// ];

interface IHouseOfWorshipWidgetProps {
  data: IHOWInfo[];
}

const HouseOfWorshipWidget = ({ data }: IHouseOfWorshipWidgetProps) => {
  const [selectedHow, setSelectedHow] = useState<IHOWInfo>();
  const location = useLocation();

  const fetchHowInfoGetLocation = useQueries({
    queries: data?.map((d: IHOWInfo) => {
      const fullAddress = `${d.address}, ${d.city}, ${d.state}, ${d.zipCode}`;
      return {
        queryKey: ['GET_HOW_GEO_CODE', d],
        queryFn: () => getAddressDecode(fullAddress),
        select: (resData: { data: IGetAddressDecodeResData }) => {
          const { lat, lng } = resData.data;
          return { ...d, coordinates: { lat, lng } };
        },
      };
    }),
  });

  const howInfoGeoLocated = fetchHowInfoGetLocation?.map((d) => d.data);

  return (
    <>
      <section className='mt-8'>
        <Card title='House Of Worship'>
          {!howInfoGeoLocated && !fetchHowInfoGetLocation[0]?.isFetching && (
            <div className='w-full flex justify-center items-center h-screen/2'>
              <div>
                <div className='flex justify-center items-center gap-2 text-primaryColor-normal'>
                  <LocationMarkerIcon className='h-8 w-8' />
                  <h1>No Projects</h1>
                </div>
                <p>There are no house of worship applications to display.</p>
              </div>
            </div>
          )}

          <div className='w-full grid grid-cols-6 h-screen/2'>
            {fetchHowInfoGetLocation[0]?.isFetching && (
              <div className='col-span-6'>
                <LoadingMapCard />
              </div>
            )}
            {/* <div className='col-span-2 p-5 flex flex-col justify-between'>
                <div>
                  <h3 className='font-bold underline hover:text-primaryColor-normal'>
                    <Link to={`/app/sherpa/projects/${selectedProject?.name}`}>
                      {selectedProject?.name}
                    </Link>
                  </h3>
                  <div className='text-neutralColor-normal text-xs'>
                    <div>
                      <span>{selectedProject?.address}</span>
                      <span>
                        {selectedProject?.city}, {selectedProject?.state},{' '}
                        {selectedProject?.zipCode}
                      </span>
                    </div>
                  </div>
                </div>
                <ul className='py-4 divide-y'>
                  <li className='flex justify-between py-6 text-neutralColor-normal font-semibold'>
                    <span>Location</span>
                    <span className='text-primaryColor-normal'>
                      {selectedProject.city}, {selectedProject.state}
                    </span>
                  </li>
                  <li className='flex justify-between py-6 text-neutralColor-normal font-semibold'>
                    <span>Church Established</span>
                    <span className='text-primaryColor-normal'>
                      1997 June 17
                    </span>
                  </li>
                  <li className='flex justify-between py-6 text-neutralColor-normal font-semibold'>
                    <span>Capacity</span>
                    <span className='text-primaryColor-normal'>
                      20,000 People
                    </span>
                  </li>
                  <li className='flex justify-between py-6 text-neutralColor-normal font-semibold'>
                    <span>Visiting Hours</span>
                    <span className='text-neutralColor-dark w-1/2'>
                      Wed 1:00 PM to 6:00 PM, Thu-Sun 10:00 AM to 6:00 PM
                    </span>
                  </li>
                </ul>
              </div> */}
            <div className='col-span-6 w-full border-l p-5'>
              {!fetchHowInfoGetLocation[0]?.isFetching &&
                howInfoGeoLocated[0] && (
                  <GoogleMap
                    defaultCenter={{
                      lat: howInfoGeoLocated[0].coordinates.lat,
                      lng: howInfoGeoLocated[0].coordinates.lng,
                    }}
                  >
                    {howInfoGeoLocated &&
                      howInfoGeoLocated.map((how) => {
                        return (
                          <LocationMarker
                            key={how?.id}
                            lat={how?.coordinates?.lat}
                            lng={how?.coordinates?.lng}
                          >
                            <div className='relative'>
                              {selectedHow && selectedHow?.id === how?.id && (
                                <div
                                  onClick={() => setSelectedHow(undefined)}
                                  className='bg-white border rounded absolute p-3 bottom-4 left-5 w-56'
                                >
                                  <XIcon className='h-4 w-4 absolute right-1 top-1 text-neutralColor-normal hover:text-red-500' />
                                  <Link
                                    to={`${location.pathname.replace(
                                      'dashboard',
                                      'applications'
                                    )}/${selectedHow?.id}/application_details`}
                                  >
                                    <p className='font-semibold text-primaryColor-normal underline'>
                                      {selectedHow?.name}
                                    </p>
                                  </Link>
                                  <p className='text-xs'>
                                    {selectedHow?.address}
                                  </p>
                                  <p className='text-xs'>
                                    {selectedHow?.city}, {selectedHow?.state},{' '}
                                    {selectedHow?.zipCode}
                                  </p>
                                  <div className='mt-2 text-sm flex justify-between gap-2'>
                                    <span>Clergy Leader</span>
                                    <span className='font-semibold'>
                                      {selectedHow?.clergyLeader}
                                    </span>
                                  </div>
                                  <div className='mt-2 text-sm flex justify-between gap-2'>
                                    <span>Email</span>
                                    <span className='font-semibold'>
                                      {selectedHow?.email}
                                    </span>
                                  </div>
                                  <div className='mt-2 text-sm flex justify-between gap-2'>
                                    <span>Phone</span>
                                    <span className='font-semibold'>
                                      <PhoneNumberFormatDisplay
                                        value={selectedHow?.phone || 'none'}
                                      />
                                    </span>
                                  </div>
                                </div>
                              )}
                              {how && (
                                <LocationMarkerIcon
                                  onClick={() => setSelectedHow(how)}
                                  className={
                                    selectedHow?.id === how?.id
                                      ? 'h-8 w-8 text-black'
                                      : 'h-8 w-8 text-red-500 '
                                  }
                                />
                              )}
                            </div>
                          </LocationMarker>
                        );
                      })}
                  </GoogleMap>
                )}
            </div>
          </div>
        </Card>
      </section>
    </>
  );
};

export default HouseOfWorshipWidget;
